import { apiClient } from 'api/api-client'

export const recalculateTeamRating = () => apiClient.post(`/teams-ratings/recalculate`)
